import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum MarketDataFeedsFormErrorStatesEnum {
    CreateMarketDataFeedFailed = ErrorStateScheduleEnum.MarketDataFeedsFormStatesStartIndex,
    DeleteMarketDataFeedFailed,
    DeleteMarketDataFeedBundleFailed,
    CreateMarketDataFeedBundleFailed,
    UpdateMarketDataFeedFailed,
    MarketDataFeedBundleUpdateFailed,
    GetMarketDataDetailFailed,
    GetExchangesFailed,
    GetPlatformFrontendsFailed,
}
